export const Risk = {
    ID: 0,
    POV: 1,
    HAV: 2,
    SKLA: 3,
    SPOL: 9,
    ASISTENCE: 104,
    SEDADLA: 105,
    BALICEK: 106,
    NA100PRO: 107,
    ZAVAZADLA: 108,
    NAHR: 109,
    ODCPOV: 110,
    ASISTENCE2: 111,
    RAFKY: 112,
    SEDADLAD: 113,
    SEDADLAR: 114,
    GAP: 115,
    TELE: 116,
    DirectLiquidation: 117,
    GARANCECENY: 118,
    HAVARIE: 119,
    ZIVEL: 120,
    STRZVI: 121,
    POSKZVI: 122,
    VANDAL: 123,
    SERVISPRO: 124,
    PRIRODNIRIZIKA: 125,
    MINIHAV: 126,
    SPORT: 127,
    ODCPOV1: 128,
    ODCPOV2: 129,
    ODCPOV3: 130,
    ZVER: 131,
    DROBNE_ZAVADY: 132,
    RODICE: 133,
    OPRAVA_ROZPOCTEM: 134,
    PRAC_NESCHOPNOST: 135,
    EXTRA_BONUS: 136,
    POURAZ: 137,
    PORUCHA: 138,
    KLIKA: 139,
    TOTALKA: 140,
    AKCE: 150,
    MINIGAP: 160,
    GAP36EX: 162,
    PRACSTROJ: 163,
    PUZA: 164,
    FEE: 165,
    KABELY: 166,
    KLICE: 167,
    PNEU: 168,
    ODPOVEDNOST: 169,
    BABY_CARSEAT: 170,
    CUSTOM_SPZ: 171,
    PETS: 172,
    LEGAL_PROTECTION: 173,
    NESTANDARD_VYBAVA: 174,
    KALAMITA: 175,
    ZARUKA: 180,
    DOMSERVIS: 181,
    RESPONSIBILITY_CYCLO: 182,
    PROPERTY_TYPE: 1000,
    RANGE_TYPE: 1001,
    LIABILITY: 1002,
    SPOL_PROPERTY: 1003,
    FLOOD: 1004,
    RAIN: 1005,
    WATER_DAMAGE: 1006,
    WATER_PIPE_DAMAGE: 1007,
    OVERVOLTAGE: 1008,
    GLASS: 1009,
    ASSISTANCE: 1010,
    ASSISTANCE_WARRANTY: 1011,
    THEFT: 1012,
    RESPONSIBILITY: 1013,
    RESPONSIBILITY_REALESTATE: 1014,
    MECHANICAL_AND_ELECTRIC_DEVICE: 1015,
    SECONDARY_BUILDINGS: 1016,
    GARDEN_STUFF: 1017,
    GARDEN_FLORA: 1018,
    WATER_LOSS: 1019,
    ELECTRIC_DEVICE: 1020,
    BUILDING_COMPONENTS: 1021,
    JEWERLY: 1023,
    CASH: 1024,
    BICYCLE: 1025,
    CAR_STUFF: 1026,
    FRIDGE_STUFF: 1027,
    VANDALISM: 1028,
    NATURAL_DAMAGE: 1029,
    NONRESIDENTAL_THINGS: 1030,
    FACADE_DAMAGE: 1031,
    HOUSEHOLD: 1032,
    REALTY: 1033,
    VALUABLES: 1034,
    ACCOMODATION: 1035,
    SPOL_FLOOD: 1036,
    SPOL_RESPONSIBILITY: 1039,
    ADDITION_SPOL_RESPONSIBILITY: 1500,
    ADDITION_RESPONSIBILITY_UJMA_MOBIL: 1501,
    ADDITION_BICYCLE: 1502,
    ADDITION_PET: 1503,
    ADDITION_MEDICAL: 1504,
    ADDITION_LEGAL_ASSISTANCE: 1505,
    ADDITION_IT_ASSISTANCE: 1506,
    ADDITION_LOAN_PAYMENT: 1507,
    ADDITION_SAFE_ONLINE: 1508,
    ADDITION_PROTECT_FAMILY: 1509,
    ADDITION_VALORISATION_REALTY: 1510,
    ADDITION_VALORISATION_HOUSEHOLD: 1511,
    ADDITION_VALORISATION_GENERAL: 1512,
    ADDITION_NEW_PRICE_REALTY: 1513,
    ADDITION_NEW_PRICE_HOUSEHOLD: 1514,
    ADDITION_PERSONAL_ASSISTANCE: 1515,
    ADDITION_CYCLO_ASSISTANCE: 1516,
    ADDITION_PORTABLE_ELECTRONICS: 1517,
    ADDITION_GARDEN_EQUIPMENT: 1518,
    ADDITION_SPORT_EQUIPMENT: 1519,
    ADDITION_CONSTRUCTION_ASSEMBLY: 1520,
    ADDITION_RENT_LOSS: 1521,
    ADDITION_RESPONSIBILITY_RENT: 1522,
    ADDITION_RESPONSIBILITY_CONSTRUCTION: 1523,
    ADDITION_DAMAGE_BUILDING_COMPONENTS: 1524,
    ADDITION_EXTENDED_WARRANTY_HOUSEHOLD: 1525,
    ADDITION_EXTENDED_WARRANTY_REALTY: 1526,
    ADDITION_RESPONSIBILITY_SMALL_ELECTRONICS: 1527,
    ADDITION_RESPONSIBILITY_RENTED_THINGS: 1528,
    ADDITION_RESPONSIBILITY_ALL_REALESTATES: 1529,
    ADDITION_RESPONSIBILITY_ANIMAL: 1530,
    ADDITION_RESPONSIBILITY_RENTER: 1531,
    ADDITION_EARTHQUAKE: 1532,
    ADDITION_MUSICAL_INSTR: 1533,
    TRAVEL_RANGE: 2000,
    ADDITION_RENTED_VEHICLE: 2500, // Pojisteni vozidla z pujcovny - Direct, AxaAssistance
    ADDITION_LETO_PLUS: 2501, // Pojisteni Leto PLUS - CPP
    ADDITION_GUARD_PLUS: 2502, // Pojisteni Guard PLUS - CPP
    ADDITION_GOLF_PLUS: 2503, // Pojisteni Golf PLUS - CPP
    ADDITION_CESTA_PLUS: 2504, // Pojisteni Cesta PLUS - CPP
    ADDITION_ZIMA_PLUS: 2505, // Pojisteni Zima PLUS - CPP
    ADDITION_ZVIRE_PLUS: 2506, // Pojisteni Zvire PLUS - CPP
    ADDITION_MANUAL_WORK: 2507, // PPojisteni manualnich praci - Direct
    ADDITION_TRAVEL_SPORT_EQUIPMENT: 2508, // Pojisteni sportovniho vybaveni - Direct, Colonnade
    ADDITION_RISK_SPORT: 2509, // Pojisteni rizikovych sportu - Direct
    ADDITION_HOUSEHOLD_IN_VACATION: 2510, // Pojisteni domacnosti v dobe dovolene v zahranici - CSOB
    ADDITION_ALCOHOL_CAUSE: 2511, // Pojisteni "drink povolen" - AxaAssistance
    ADDITION_DOCTOR_ON_PHONE: 2512, // Pojisteni "doktor na telefonu" - Direct, AxaAssistance
    ADDITION_TRIP_WITH_PET: 2513, // Pojisteni "cesta s mazlickem" - Colonnade
    ADDITION_SPOILT_VACATION: 2514, // Pojisteni zkazene dovolene - Direct
    ADDITION_MINI_KASKO: 2515, // Pojisteni auta do zahranici (zver, vandalismus, zivel) - Direct
    ADDITION_CESTA: 2516, // Pojištění cesty (přerušení, zmeškání odjezdu) - ČSOB
    ADDITION_TRAVEL_PET: 2517, // Pojištění mazlíčků na cesty - Direct
    DEFEND: 8888,
    UNKNOWN: 9999,
}

export type Risk = typeof Risk[keyof typeof Risk]

export default Risk